import React, { useEffect, useState } from 'react';
import { terms } from '../constants';
import Select from '@lwt-helix/select';
import { Input, Label } from '@lwt-helix/controls';
import { Button } from '@lwt-helix/buttons';
import { setStateData } from '../../common/helpers/state';
import { buildMlsSelectOptions } from '../helpers/helpers';
import { useSearchStore } from '../../store/store';
import Loader from '@lwt-helix/loader';
import { showToast, toastTypes } from '../../common/helpers/toast';
import { toastMessages } from '../../constants';
import { ToastContainer } from '@lwt-helix/toast';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuthStore } from '../../store/auth/store';
import { getAgentInfo } from '../../service/mlsInfo';
import { createAgent } from '../../service/agent-metrics';
import PropTypes from 'prop-types';

const Validation = ({ isMyProfile }) => {

    const history = useHistory();

    const [state, setState] = useState({
        mlsList: [],
        selectedMlsOption: { label: terms.selectYourMls, value: null },
        isFormValid: false,
        isLoading: false,
        isAgentCreated: false,
        toastProps: null,
    });

    const {
        getMlsList,
    } = useSearchStore(state => ({
        getMlsList: state.getMlsList
    }));

    const {
        isXamUserValidated,
        setIsXamUserValidated,
    } = useAuthStore(state => ({
        isXamUserValidated: state.isXamUserValidated,
        setIsXamUserValidated: state.setIsXamUserValidated,
    }));

    useEffect(() => {
        if (isXamUserValidated) {
            history.replace('/market-share/totals', {});
        }

        const getMlsData = async () => {
            const mlsList = await getMlsList();
            if (mlsList?.error) return;
            setStateData('mlsList', mlsList, setState);
        };
        getMlsData();
    }, []);

    useEffect(() => {
        const isValid = state.selectedMlsOption?.value?.mlsId && state.agentId?.trim().length > 0;
        setStateData('isFormValid', isValid, setState);
    }, [state.selectedMlsOption, state.agentId]);

    const handleOptionsChange = (option) => {
        setStateData('selectedMlsOption', option, setState);
    };

    const handleAgentIdChange = (agentId) => setStateData('agentId', agentId, setState);

    const handleSaveAndContinue = async () => {
        setStateData('isLoading', true, setState);

        const agentList = [{
            mlsId: state.selectedMlsOption?.value?.mlsId,
            agentId: state.agentId
        }];

        const validationResult = await getAgentInfo(agentList);
        const activeAgentsOffices = validationResult.length > 0
            && validationResult.filter(agent => agent.isAgentActive);

        if (!activeAgentsOffices?.length || activeAgentsOffices?.length === 0) {
            showToast(toastTypes.error, toastMessages.error.agentNotValidated, setState);
        } else {
            try {
                const response = await createAgent(
                    state.agentId,
                    state.selectedMlsOption?.value?.mlsId.toString()
                );
                if (!response?.error && response !== 409) {
                    setStateData('isAgentCreated', true, setState);
                    setIsXamUserValidated(true);
                    history.replace('/market-share/totals', { fromValidation: true });
                } else {
                    showToast(toastTypes.error, toastMessages.error.agentNotValidated, setState);
                }
            } catch (error) {
                console.error('Error creating agent:', error);
                showToast(toastTypes.error, toastMessages.error.agentNotValidated, setState);
            }
        }
        setStateData('isLoading', false, setState);
    };

    const mlsOptions = state.mlsList?.length ? buildMlsSelectOptions(state.mlsList) : [];

    return <div className='validation-wrapper'>
        <div className={`${!isMyProfile && 'raised-border p-5 mt-5'} bg-white d-flex flex-column align-items-center`}>

            {!isMyProfile
                ? <div className='text-center mb-3'>
                    <img
                        height='40'
                        src='//assets.lwolf.com/img/lw-logo-dark.svg'
                        alt='Logo'
                        className='mb-5'
                    />
                    <h5>{terms.thankYou}</h5>
                    <p>{terms.welcomeMessage}</p>
                </div>
                : <h4 className='mb-4'>{terms.connectYourMls}</h4>
            }
            <div className='w-75'>
                <div className='mb-3'>
                    <Label dataLwtId='mls-associations-label' className='font-weight-bold'>{terms.yourMLSassociation}</Label>
                    <Select
                        dataLwtId='mls-associations'
                        isClearable={false}
                        onChange={handleOptionsChange}
                        options={mlsOptions}
                        value={state.selectedMlsOption}
                        isDisabled={state.isAgentCreated}
                    />
                </div>
                <div>
                    <Label dataLwtId='mls-associations-label' className='font-weight-bold'>{terms.mlsAgentId}</Label>
                    <Input
                        dataLwtId='agent-id'
                        onChange={(e) => handleAgentIdChange(e.target.value.toUpperCase())}
                        maxLength={50}
                        placeholder={terms.enterYourMlsAgentId}
                        value={state.agentId}
                        className='ucase-ph-mixed'
                        disabled={state.isAgentCreated}
                    />
                </div>
                <div className='w-100 d-flex justify-content-center'>
                    <Button
                        dataLwtId='validation-agent-metrics-form'
                        className='btn btn-primary save-continue-button w-100'
                        disabled={!state.isFormValid || state.isAgentCreated}
                        onClick={!isMyProfile && handleSaveAndContinue}
                    >
                        {state.isLoading ? <div className='py-3'><Loader /></div> : terms.saveAndContinue}
                    </Button>
                </div>
            </div>

        </div>
        <ToastContainer
            position='toast-bottom-right'
            dataLwtId='validation-toast'
            toastProps={state.toastProps}
        />
    </div>;

};

Validation.propTypes = {
    isMyProfile: PropTypes.bool,
};

export default Validation;
